module.exports = __webpack_public_path__ + "src/assets/img/share/tips/extroversion/993c1185a5892fe3daeb9cab969494fc.png";